import HeroSection from "./components/hero-section";
import FeatureSection from "./components/feature-section";
import { SEO } from "@/components/common/seo";

export default function Teleradiology() {
  return (
    <div>
      <SEO canonical="/teleradiology" />
      <HeroSection />
      <FeatureSection />
    </div>
  );
}
